import React, { useState, useEffect } from 'react';
import { FiMessageSquare, FiSend, FiUser, FiClock } from 'react-icons/fi';
import './CommentsModal.css';

const CommentsModal = ({ task, onClose, onAddComment, formatDate }) => {
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!comment.trim() || isSubmitting) return;

        setIsSubmitting(true);
        try {
            await onAddComment(comment.trim());
            setComment('');
        } catch (error) {
            console.error('Failed to add comment:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!task) return null;

    return (
        <div className="comments-modal-overlay" onClick={onClose}>
            <div className="comments-modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="comments-modal-header">
                    <div className="comments-modal-title-section">
                        <div className="comments-header-icon">
                            <FiMessageSquare size={24} />
                        </div>
                        <div className="comments-header-info">
                            <h2>Comments</h2>
                            <div className="comments-task-info">
                                <span className="task-id-badge">{task.taskId || 'N/A'}</span>
                                <span className="task-title">{task.title}</span>
                            </div>
                        </div>
                        <button 
                            className="comments-modal-close-btn" 
                            onClick={onClose}
                            aria-label="Close"
                        >
                            ✕
                        </button>
                    </div>
                </div>

                {/* Body */}
                <div className="comments-modal-body">
                    {/* Comments List */}
                    <div className="comments-list-section">
                        {task.comments && task.comments.length > 0 ? (
                            <div className="comments-list">
                                {task.comments.map((c, idx) => (
                                    <div key={idx} className="comment-item">
                                        <div className="comment-avatar">
                                            <FiUser size={16} />
                                        </div>
                                        <div className="comment-content">
                                            <div className="comment-header">
                                                <span className="comment-author">{c.userName}</span>
                                                <span className="comment-date">
                                                    <FiClock size={12} />
                                                    {formatDate(c.createdAt)}
                                                </span>
                                            </div>
                                            <div className="comment-text">{c.comment}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-comments">
                                <FiMessageSquare size={48} />
                                <p>No comments yet</p>
                                <span>Be the first to add a comment!</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer - Add Comment */}
                <div className="comments-modal-footer">
                    <form onSubmit={handleSubmit} className="add-comment-form">
                        <div className="comment-input-section">
                            <textarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder="Write a comment..."
                                className="comment-textarea"
                                rows={3}
                                disabled={isSubmitting}
                            />
                        </div>
                        <div className="comment-actions">
                            <div className="comment-counter">
                                {comment.length}/500
                            </div>
                            <button 
                                type="submit" 
                                className="btn-send-comment"
                                disabled={!comment.trim() || isSubmitting}
                            >
                                <FiSend size={16} />
                                {isSubmitting ? 'Sending...' : 'Send'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CommentsModal;